import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const MedSplInstrForm = (props) => {
    const initialFormData = {
        splinstr: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const formRef = useRef(null);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);

    useEffect(() => {
        const val = props.splinstrvalue || props.medsplvalue;
        if (val && (val.spl_instr_id || val.instruction_id || val.splinstr_id || val.id)) {
            const { instruction, special_instruction, is_active, spl_instr_id, instruction_id, splinstr_id, id } = val;
            setFormData({
                splinstr: instruction || special_instruction || "",
                isactive: is_active == 1 || is_active === '1' || is_active === true,
                id: spl_instr_id || instruction_id || splinstr_id || id || ""
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.splinstrvalue, props.medsplvalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsSplInstrUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/prescriptions/add-prescription-instruction/` : `${process.env.REACT_APP_SERVER_URL}/prescriptions/update-prescription-instruction/`;
        let pelmedsSplInstrData = isAddMode ? 
            { "instruction": formData.splinstr, "group_id": localStorage.getItem("groupId") || '', "is_active": 1 } :
            { "instruction": formData.splinstr, "group_id": localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id };

        const { data } = await axios.post(pelmedsSplInstrUrl, pelmedsSplInstrData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success(isAddMode ? "Special Instruction added successfully" : "Special Instruction updated successfully");
        }
        else {
            toast.info("Error while adding/updating Special Instruction");
        }

        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");

        props.onCallParent();
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Special Instruction</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            placeholder='Special Instruction Name'
                            value={formData.splinstr}
                            name="splinstr"
                            size="sm"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="mt-4 w-50"
                            size="sm"
                            disabled={!formData.splinstr}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};
export default MedSplInstrForm;
